import slidesToShow from './slidesToShow';
import infinite from './infinite';
import clickToChange from './clickToChange';
import autoplay from './autoplay';
import rtl from './rtl';
import centered from './centered';
import slidesToScroll from './slidesToScroll';
import arrows from './arrows';
import fastSwipe from './fastSwipe';

export default {
  slidesToShow,
  infinite,
  clickToChange,
  autoplay,
  rtl,
  centered,
  slidesToScroll,
  arrows,
  fastSwipe,
};
